/* eslint-disable @typescript-eslint/no-explicit-any */
import { Module, Commit } from "vuex";

// Define the interface for the object
interface T {
  id: number;
}

// Define the type for the state
type M = T[];

const initialState: M = [];

export const currentPath: Module<M, any> = {
  state: initialState,
  mutations: {
    storeCurrentPath(state: M, D: T[]) {
      state.splice(0, state.length, ...D);
    },
  },
  actions: {
    fetchCurrentPath({ commit }: { commit: Commit }, items: T[]) {
      commit("storeCurrentPath", items);
    },
  },
  getters: {
    getCurrentPathById:
      (state: M) =>
      (id: number): T | undefined => {
        return state.find((i) => i.id === id);
      },
  },
};

// T: Type
// M: State object
// D: Data
